import moment from 'moment';
import { Fragment } from 'react';
import { Button } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { ColumnToggle, Search } from 'react-bootstrap-table2-toolkit';

const QREvents = ({ users }) => {

    const columns = [
        { 
            dataField: 'dataID', 
            text: 'ID', 
            sort: true,
            headerAttrs: { width: 35 },
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' } 
        },
        { 
            dataField: 'eventTitle', 
            text: 'Event Title', 
            sort: true, 
            headerAttrs: { width: 200 },
            // attrs: { width: 100 },  
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' } 
        },
        // { 
        //     dataField: 'eventDesc', 
        //     text: 'Event Description',
        //     headerAttrs: { width: 150 },
        //     // attrs: { width: 150 }, 
        //     sort: true, 
        //     // attrs: { width: 800 }, 
        //     headerStyle: { textAlign: 'left' }, 
        //     style: { textAlign: 'left' } 
        // },
        { 
            dataField: 'userID', 
            text: 'Badge ID', 
            sort: true, 
            headerAttrs: { width: 90 },
            // attrs: { width: 800 }, 
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' } 
        },
        { 
            dataField: 'userDate', 
            text: 'User Date', 
            sort: true, 
            headerAttrs: { width: 100 },
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' },
            formatter: (cell,row) => {
                return <>{moment(row.userDate).format('DD MMM YYYY')}</>
            }
        },
        { 
            dataField: 'userName', 
            text: 'Username', 
            sort: true, 
            headerAttrs: { width: 100 },
            // attrs: { width: 800 }, 
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' }
        },
        { 
            dataField: 'userFullName', 
            text: 'Full Name', 
            sort: true, 
            headerAttrs: { width: 200 },
            // attrs: { width: 800 }, 
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' }
        },
        { 
            dataField: 'userEmail', 
            text: 'Email', 
            sort: true, 
            headerAttrs: { width: 300 },
            // attrs: { width: 800 }, 
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' }
        },
        { 
            dataField: 'userDept', 
            text: 'Department', 
            sort: true, 
            headerAttrs: { width: 150 },
            // attrs: { width: 800 }, 
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' }
        },
        { 
            dataField: 'userDiv', 
            text: 'Division', 
            sort: true, 
            headerAttrs: { width: 160 },
            // attrs: { width: 800 }, 
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' }
        },
        { 
            dataField: 'userFac', 
            text: 'Factory', 
            sort: true, 
            headerAttrs: { width: 130 },
            // attrs: { width: 800 }, 
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' }
        },
        { 
            dataField: 'usertype', 
            text: 'Employee Type', 
            sort: true, 
            headerAttrs: { width: 130 },
            // attrs: { width: 800 }, 
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' }
        },
        { 
            dataField: 'createdBy', 
            text: 'Created By', 
            sort: true, 
            headerAttrs: { width: 130 },
            // attrs: { width: 800 }, 
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' } 
        },
        { 
            dataField: 'createdByName', 
            text: 'Created By (Name)', 
            sort: true, 
            headerAttrs: { width: 150 },
            // attrs: { width: 800 }, 
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' } 
        },
        { 
            dataField: 'createdDate', 
            text: 'Created Date', 
            sort: true, 
            headerAttrs: { width: 130 },
            // attrs: { width: 800 }, 
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' },
            formatter: (cell,row) => {
                return <>{moment(row.createdDate).format('DD MMM YYYY')}</>
            }
        },
        // { 
        //     dataField: 'startDate', 
        //     text: 'Start Date', 
        //     sort: true,
        //     headerStyle: { textAlign: 'center' },  
        //     style: { textAlign: 'center' },
        //     formatter: (cell,row) => {
        //         return <>{moment(row.startDate).format('DD MMM YYYY')}</>
        //     }
        // },
        // { 
        //     dataField: 'endDate', 
        //     text: 'End Date', 
        //     sort: true,
        //     attrs: { width: 160 },
        //     formatter: (cell,row) => {
        //         return <>{moment(row.endDate).format('DD MMM YYYY')}</>
        //     }
        // }
    ]

    const { SearchBar, ClearSearchButton } = Search;

    const { ToggleList } = ColumnToggle;

    const ExportCSVButton = (props) => {
        const handleClick = () => {
            props.onExport();
        };

        return (
            <Button 
                variant='success' 
                onClick={handleClick} 
                style={{ float: 'right'}}
            >
                Export to CSV
            </Button>
        );
    };
    
    return (
        <Fragment>
            <ToolkitProvider
                keyField='dataID'
                data={users}
                columns={columns}
                columnToggle
                search
                exportCSV={{
                    fileName: 'qreventreport.csv'
                }}
            >
            {
                props => (
                <div style={{marginTop: '10px'}}>
                    <SearchBar { ...props.searchProps } />
                    <ClearSearchButton { ...props.searchProps } />
                    <ExportCSVButton { ...props.csvProps } />
                    <hr />
                    <div><strong>Display Options</strong></div>
                    <ToggleList
                        contextual='outline-primary'
                        btnClassName='qr-toggle-column-btn-custom-class'
                        { ...props.columnToggleProps } 
                    />
                    <BootstrapTable
                        classes='qrevent-table'
                        bordered={false}
                        { ...props.baseProps }
                        pagination={paginationFactory()}
                        headerWrapperClasses='infohub-header'
                        noDataIndication='List is empty.'
                    />
                </div>
                )
            }
            </ToolkitProvider>
        </Fragment>
    );
};

export default QREvents;
